import styled from 'styled-components';

export default comp => styled(comp)`
  .block-heading {
    h1 {
      @media (max-width: ${props => props.theme.breakpoints.tablet}) {
        font-size: ${props => props.theme.type.largeMobile};
        line-height: ${props => props.theme.lineHeights.largeMobile};
        letter-spacing: ${props => props.theme.letterSpacing.large};
      }
      @media (min-width: ${props =>
          props.theme.breakpoints.tablet}) and (max-width: ${props =>
          props.theme.breakpoints.desktop}) {
        font-size: ${props => props.theme.type.large};
        line-height: ${props => props.theme.lineHeights.large};
        letter-spacing: ${props => props.theme.letterSpacing.large};
      }
    }
  }

  .block-faq_menu {
    overflow: visible;
  }

  .content {
    width: 100%;

    .block-featured_media {
      margin: 1rem 0;
    }

    .block-loan_application_package {
      padding-top: 0;
      overflow: visible;

      .dropdown {
        @media (min-width: ${props => props.theme.breakpoints.tablet}) {
          display: flex;
          flex-direction: row;
          align-items: center;

          .result {
            padding-left: 2rem;
          }
        }
      }
    }
  }
`;
